import { parseApiError } from '@/helpers/api-requests';

const AutocompleteParent = {
  methods: {
    async getAutocompleteData(apiPath, filter, prop='id', searchTextProp='name', getDisplayText=(item) => item[searchTextProp], includes=[]) {
      let filterString = `filter=${filter}`;
      if (includes.length > 0) filterString = `${filterString}&`
      return await this.$http({
        url: `${apiPath}?${filterString}${includes.length >0 ? "include=" : ""}${includes.join(',')}`,
        method: 'GET',
      })
        .then(resp => {
          if (resp.data.error !== undefined) {
            return Promise.reject(resp.data.error);
          }
          const parsedData = resp.data.data.map(item => ({
            prop: item[prop],
            searchText: item[searchTextProp],
            displayText: getDisplayText(item),
          }));
          return Promise.resolve([parsedData, resp.data.data]);
        })
        .catch(parseApiError);
    },
  },
};

export default AutocompleteParent;
